import { Fragment, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "../src/AppState/store";
import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import RootApp from "./RootApp";


function App() {
  // IMPORTANT: OktaAuth must be stable across renders.
  // Recreating it on navigation can cause Okta context churn and interceptor teardown.
  const oktaAuth = useMemo(
    () =>
      new OktaAuth({
        issuer: process.env.REACT_APP_OKTA_ISSUER!,
        clientId: process.env.REACT_APP_OKTA_CLIENTID,
        redirectUri:
          globalThis.location.origin + process.env.REACT_APP_OKTA_REDIRECTURI,
        scopes: ["openid", "profile", "email", "offline_access"],
        pkce: true,
        tokenManager: {
          storage: "localStorage", // Or "sessionStorage" if you prefer
          autoRenew: true,
          autoRemove: true,
          expireEarlySeconds: 60, // Optional buffer
        },
      }),
    []
  );

  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || "/", globalThis.location.origin));
  };


  return (
    <Fragment>
      {}
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <RootApp />
          </Security>
        </PersistGate>
      </Provider>
    </Fragment>
  );
}

export default App;
